import { useIntl } from 'react-intl';

import type { EditorPluginAIProvider } from '../../types/types';

export const useAIUsageDisclaimer = ({
	editorPluginAIProvider,
}: {
	editorPluginAIProvider: EditorPluginAIProvider;
}): {
        text: string;
        tooltip: string;
        url: string | undefined;
    } | undefined => {
	const { formatMessage } = useIntl();
	let disclaimer;
	const { aiUsageDisclaimer } = editorPluginAIProvider;
	if (aiUsageDisclaimer) {
		disclaimer = {
			text: formatMessage(aiUsageDisclaimer.text),
			tooltip: formatMessage(aiUsageDisclaimer.tooltip),
			url: aiUsageDisclaimer.url,
		};
	}
	return disclaimer;
};
